module.exports = __webpack_public_path__ + "img/horizontal_7_4_9006.242dffc8.png";